const MONTHS = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December",
];

/**
 * Cross-browser month/year picker (native <select> — works identically on
 * Safari/Firefox/Edge/mobile, unlike <input type="month"> which has no native
 * picker on Safari & Firefox desktop).
 *
 * value/onChange use the same "YYYY-MM" string contract as <input type="month">.
 */
export default function MonthPicker({
  value,
  onChange,
  yearsBack = 5,
  yearsForward = 5,
  testId = "month",
  className = "",
}) {
  const now = new Date();
  const [yStr, mStr] = (value || `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}`).split("-");
  const year = parseInt(yStr, 10);
  const monthIdx = parseInt(mStr, 10) - 1;

  const baseYear = now.getFullYear();
  const years = [];
  for (let y = baseYear - yearsBack; y <= baseYear + yearsForward; y++) years.push(y);
  // Make sure the currently-selected year is always available even if outside the window.
  if (!years.includes(year)) years.push(year);
  years.sort((a, b) => a - b);

  const emit = (y, m) => onChange(`${y}-${String(m + 1).padStart(2, "0")}`);

  const selCls =
    "bg-white border border-slate-200 rounded-lg px-2.5 py-1.5 text-sm text-navy " +
    "focus:border-orange focus:ring-2 focus:ring-orange/20 outline-none cursor-pointer " +
    className;

  return (
    <div className="inline-flex items-center gap-2" data-testid={`${testId}-picker`}>
      <select
        aria-label="Month"
        data-testid={`${testId}-month-select`}
        className={selCls}
        value={monthIdx}
        onChange={(e) => emit(year, parseInt(e.target.value, 10))}
      >
        {MONTHS.map((label, i) => (
          <option key={label} value={i}>{label}</option>
        ))}
      </select>
      <select
        aria-label="Year"
        data-testid={`${testId}-year-select`}
        className={selCls}
        value={year}
        onChange={(e) => emit(parseInt(e.target.value, 10), monthIdx)}
      >
        {years.map((y) => (
          <option key={y} value={y}>{y}</option>
        ))}
      </select>
    </div>
  );
}
